const DocumentFill = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M6.81445 22.418C5.80534 22.418 5.04688 22.1641 4.53906 21.6562C4.03776 21.1484 3.78711 20.3835 3.78711 19.3613V4.54688C3.78711 3.53125 4.03776 2.76628 4.53906 2.25195C5.04688 1.73763 5.80534 1.48047 6.81445 1.48047H11.2969V8.64844C11.2969 9.87891 11.9121 10.4941 13.1426 10.4941H20.2129V19.3613C20.2129 20.377 19.959 21.1387 19.4512 21.6465C18.9499 22.1608 18.1947 22.418 17.1855 22.418H6.81445ZM13.1719 9.15625C12.8138 9.15625 12.6348 8.98047 12.6348 8.62891V1.58789C12.8366 1.62044 13.0417 1.70833 13.25 1.85156C13.4583 1.98828 13.6764 2.17383 13.9043 2.4082L19.2852 7.88672C19.5195 8.1276 19.7051 8.34896 19.8418 8.55078C19.9785 8.7526 20.0632 8.95443 20.0957 9.15625H13.1719Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default DocumentFill;
